<template>
    <div id="application-page"> <!--Application has to be wrapped within a main div tag, the vue application lives within it-->

        <div id="version-desktop">
            <div id="desktop-app">

                <v-overlay
                        absolute="absolute"
                        opacity="0.6"
                        color="black"
                        :value="desktopOverlay">

                  <div style="backdrop-filter: blur(3px);width: 100vw; height: 100vh; display: flex; justify-content: center; align-items: center; background-color: rgba(0,0,0,0.9) ">
                      <v-btn v-if="e1 == 3 || e1 == 4" absolute @click="desktopOverlay = false" icon color="white" style="position: absolute; top: 2%; right: 2%">
                          <v-icon>fas fa-times</v-icon>
                      </v-btn>
                      <v-stepper flat color="red" style="width: 500px; height: 300px; margin: 0!important; padding: 0!important; background: rgba(0,0,0,0)" v-model="e1">
                          <v-stepper-items style="height: 100%; width: 100%; margin: 0!important;" color="transparent">
                              <v-stepper-content color="transparent" style="height: 100%; width: 100%; margin: 0!important; padding: 0!important;" step="1">
                                  <v-card flat
                                          color="transparent"
                                          height="100%"
                                          width="100%"
                                  >
                                      <div style="width: 100%; height: 60%; display: flex; justify-content: center; align-items: center;">
                                          <v-progress-circular
                                                  color="white"
                                                  width="7"
                                                  size="100"
                                                  indeterminate
                                          ></v-progress-circular>
                                      </div>
                                      <div style="width: 100%; height: 40%; font-size: 4vh; color: white">
                                          Processing Payment
                                      </div>
                                  </v-card>

                              </v-stepper-content>
                              <v-stepper-content color="transparent" style="height: 100%; width: 100%; margin: 0!important; padding: 0!important;" step="2">
                                  <v-card flat
                                          color="white"
                                          height="100%"
                                          width="100%"
                                  >
                                              <div style=" font-size: 3vh ;width: 100%; height: 20%; border-radius: 0!important; color: rgba(0,0,0,0.6);  border-bottom-style: solid; border-color: rgba(0,0,0,0.3); border-bottom-width: 1px; display: flex; justify-content: center; align-items: center">

                                                  <div style=" padding-left: 10% ;float: left ;width: 90%; height: 100%; display: flex; justify-content: center; align-items: center">
                                                      Order Summary
                                                  </div>

                                                  <div style="float: left ;width: 10%; height: 100%; display: flex; justify-content: center; align-items: center">
                                                      <v-btn small color="rgba(0,0,0,0.6)" @click="desktopOverlay = false" icon>
                                                          <v-icon>
                                                              fas fa-times
                                                          </v-icon>
                                                      </v-btn>
                                                  </div>


                                              </div>
                                              <div style="width: 100%; height: 40%; color: rgba(0,0,0,0.6); display: flex; justify-content: center; align-items: center">

                                                  <div style="width: 50%; height: 100%; float: left; color: black">

                                                      <div style="width: 100%; height: 33.33%; display: flex; justify-content: center; align-items: center; font-weight: bold">
                                                          Bundle:
                                                      </div>

                                                      <div style="width: 100%; height: 33.33%; display: flex; justify-content: center; align-items: center; font-weight: bold">
                                                          You Receive:
                                                      </div>

                                                      <div style="width: 100%; height: 33.33%; display: flex; justify-content: center; align-items: center; font-weight: bold">
                                                          You Pay:
                                                      </div>

                                                  </div>

                                                  <div style="width: 50%; height: 100%; float: left; color: black">

                                                      <div style="width: 100%; height: 33.33%; display: flex; justify-content: center; align-items: center; font-weight: bold">

                                                          <div v-if="showDynamicBadge == false" :id="desktopPrePurchaseBundleId" style="width: 50%; height: 80%; border-radius: 10px; display: flex; justify-content: center; align-items: center; color: white">
                                                              {{desktopPrePurchaseBundleTitle}}
                                                          </div>


                                                          <div v-if="showDynamicBadge" v-bind:style="{background:desktopPrePurchaseBundleIdPromo}" style="background-size: cover ;width: 50%; height: 80%; border-radius: 10px; display: flex; justify-content: center; align-items: center; color: white">
                                                              {{desktopPrePurchaseBundleTitle}}
                                                          </div>


                                                      </div>

                                                      <div style="width: 100%; height: 33.33%; display: flex; justify-content: center; align-items: center; font-weight: bold">

                                                          <v-icon v-if="customerRegion == 1" small style="padding-right: 5px" color="black">
                                                              fas fa-pound-sign
                                                          </v-icon>

                                                          <v-icon v-if="customerRegion == 2" small style="padding-right: 5px" color="black">
                                                              fas fa-coins
                                                          </v-icon>

                                                          {{creditToReceive}}

                                                      </div>

                                                      <div style="width: 100%; height: 33.33%; display: flex; justify-content: center; align-items: center; font-weight: bold">
                                                          <v-icon v-if="customerRegion == 1" small style="padding-right: 5px" color="black">
                                                              fas fa-pound-sign
                                                          </v-icon>

                                                          <v-icon v-if="customerRegion == 2" small style="padding-right: 5px" color="black">
                                                              fas fa-dollar-sign
                                                          </v-icon>

                                                          {{amountSelected}}
                                                      </div>

                                                  </div>


                                              </div>
                                              <div style="width: 100%; height: 20%; color: rgba(0,0,0,0.6); display: flex; justify-content: center; align-items: center">

                                                  <div style="width: 55%; height: 100%; display: flex; justify-content: center; align-items: center">
                                                      <paypal-checkout
                                                              env="production"
                                                              :amount="amountSelected"
                                                              :currency="currencyCode"
                                                              v-bind:client="paypal"
                                                              :button-style="mystyle"
                                                              v-on:payment-completed="processPayment"
                                                              v-on:payment-cancelled="processFailedPayment">
                                                      </paypal-checkout>
                                                  </div>

                                              </div>
                                              <div style="width: 100%; height: 20%; color: rgba(0,0,0,0.6); font-size: 1.75vh; display: flex; justify-content: center; align-items: center">
                                                  <div v-if="this.desktopAdditionalInfo == 1" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
                                                      {{computedBronzeAdditionalInfo}}
                                                  </div>

                                                  <div v-if="this.desktopAdditionalInfo == 2" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
                                                      {{computedSilverAdditionalInfo}}
                                                  </div>

                                                  <div v-if="this.desktopAdditionalInfo == 3" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
                                                      {{computedGoldAdditionalInfo}}
                                                  </div>

                                                  <div v-if="this.desktopAdditionalInfo == 4" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
                                                      {{computedPlatinumAdditionalInfo}}
                                                  </div>

                                                  <div v-if="this.desktopAdditionalInfo == 5" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
                                                      {{computedPromoAdditionalInfo}}
                                                  </div>
                                              </div>
                                  </v-card>

                              </v-stepper-content>
                              <v-stepper-content color="transparent" style="height: 100%; width: 100%; margin: 0!important; padding: 0!important;" step="3">
                                  <v-card flat
                                          color="transparent"
                                          height="100%"
                                          width="100%"
                                  >
                                      <div style="width: 100%; height: 40%; display: flex; justify-content: center; align-items: center;">
                                                                      <v-icon style="font-size: 25vh" color="green">
                                                                          fas fa-check
                                                                      </v-icon>
                                      </div>
                                      <div style="width: 100%; height: 20%; font-size: 4vh; color: white">
                                                                          Payment Processed
                                      </div>
                                      <div style="width: 100%; height: 10%; font-size: 3vh; color: white">
                                                                          Order Number: {{transactionNumberToUser}}
                                      </div>
                                      <div style="width: 100%; height: 10%; font-size: 3vh; color: white">
                                                                          For any inquiries please do not hesitate and contact us on <br>
                                                                          <b>{{regionCustomerCare}}</b>
                                      </div>

                                  </v-card>

                              </v-stepper-content>
                              <v-stepper-content color="transparent" style="height: 100%; width: 100%; margin: 0!important; padding: 0!important;" step="4">

                                  <v-card flat
                                          color="transparent"
                                          height="100%"
                                          width="100%"
                                  >
                                      <div style="width: 100%; height: 40%; display: flex; justify-content: center; align-items: center;">
                                          <v-icon style="font-size: 25vh" color="red">
                                              fas fa-times
                                          </v-icon>
                                      </div>
                                      <div style="width: 100%; height: 20%; font-size: 4vh; color: white">
                                          Oops!
                                      </div>
                                      <div style="width: 100%; height: 10%; font-size: 3vh; color: white">
                                          Payment Wasn't Processed
                                      </div>
                                      <div @click="desktopOverlay = false" style="width: 100%; height: 10%; font-size: 3vh; color: white">

                                          Please Try Again

                                      </div>

                                  </v-card>

                              </v-stepper-content>
                          </v-stepper-items>

                      </v-stepper>
                  </div>




                </v-overlay>

                <div style="width: 100%; height: 20%;display: flex; justify-content: center; align-items: center; color: white; font-weight: bold; font-size: 4vh;">
                   Choose Your Bundle
                </div>

                <div style="width: 90%; margin-right: auto; margin-left: auto; height: 55%; display: flex; justify-content: center; align-items: center">


                    <div style="width: 100%; height: 100%;"   v-for="n in length"
                         :key="n">
                        <div style="width: 100%; height: 100%; float: left; padding: 5px">

                            <v-card style="width: 100%; height: 100%">

                                <div style="width: 100%; height: 20%; display: flex; justify-content: center; align-items: center">
                                    <div id="card-banner-desktop">
                                        {{getBundle(n)}}
                                        <div v-bind:style="{ background: badgeColor, color: bundleTextColor, backgroundSize: badgeCover}" id="bundle-number-desktop">{{bundleText}}</div>
                                    </div>
                                </div>

                                <div id="card-content-desktop">
                                    <div class="bundle-info-desktop" v-if="n == 1">
                                        <div class="bundle-info-main-desktop"> {{computedBronzeMainText}}
                                            <div class="bundle-info-second-desktop"> {{computedSecondaryBronzeText}} </div>
                                        </div>
                                    </div>
                                    <div class="bundle-info-desktop" v-if="n == 2  ">
                                        <div class="bundle-info-main-desktop"> {{computedSilverMainText}}
                                            <div class="bundle-info-second-desktop"> {{computedSilverSecondaryText}} </div>
                                        </div>
                                    </div>
                                    <div class="bundle-info-desktop" v-if="n == 3  ">
                                        <div class="bundle-info-main-desktop"> {{computedGoldMainText}}
                                            <div class="bundle-info-second-desktop"> {{computedGoldSecondaryText}} </div>
                                        </div>
                                    </div>
                                    <div class="bundle-info-desktop" v-if="n == 4  ">
                                        <div class="bundle-info-main-desktop"> {{computedPlatinumMainText}}
                                            <div class="bundle-info-second-desktop"> {{computedPlatinumSecondaryText}} </div>
                                        </div>
                                    </div>
                                    <div class="bundle-info-desktop" v-if="n == 5  ">
                                        <div class="bundle-info-main-desktop"> {{computedPromoMainText}}
                                            <div class="bundle-info-second-desktop"> {{computedPromoSecond}} </div>
                                        </div>
                                    </div>
                                </div>


                                <div style="width: 100%; height: 20%; display: flex; justify-content: center; align-items: center">

                                    <v-btn @click="purchasePayPalDesktop(n)" color="#997a00" ripple width="60%;" height="50%" style="font-size: 2vh; color: white" class="text-none" rounded>
                                        Buy Now <v-icon color="white" small style="padding-left: 5px">fas fa-shopping-cart</v-icon>
                                    </v-btn>

                                </div>

                                <div style="width: 100%; height: 20%; font-size: 1.05vh; padding-left: 2%; padding-right: 2%;">

                                    <div v-if="n == 1" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
                                        {{computedBronzeAdditionalInfo}}
                                    </div>

                                    <div v-if="n == 2" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
                                        {{computedSilverAdditionalInfo}}
                                    </div>

                                    <div v-if="n == 3" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
                                        {{computedGoldAdditionalInfo}}
                                    </div>

                                    <div v-if="n == 4" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
                                        {{computedPlatinumAdditionalInfo}}
                                    </div>

                                    <div v-if="n == 5" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
                                        {{computedPromoAdditionalInfo}}
                                    </div>
                                </div>
                            </v-card>
                        </div>
                    </div>
                </div>
                <div style="width: 50%; height: 10%; margin-left: auto; margin-right: auto">
                    <div class="logo-image-holder" v-bind:style="{backgroundImage: computedGirlTextLogo}"></div>
                    <div class="logo-image-holder" style="  filter: brightness(0) invert(1);" v-bind:style="{backgroundImage: computedChatTubeLogo}"></div>
                    <div class="logo-image-holder" style="  filter: brightness(0) invert(1);" v-bind:style="{backgroundImage: computedBabeFlirtLogo}"></div>
                    <div class="logo-image-holder" v-bind:style="{backgroundImage: computedGayTextLogo}"></div>
                </div>

                <div style="width: 100%; height: 15%">
                    <div style="height: 30%; width: 100%; color: white; font-size: 0.75vw; display: flex; justify-content: center; align-items: center; padding-right: 10%; padding-left: 10%">
                        You must be 18+ and be the bill payer or have the bill payers permission to use this service. To stop all messages text STOP to 85722. Costs are plus your standard network charge. You will receive free marketing messages by signing up to this service, text XSTOP to 85722 at any time to opt out. Service Provided by All Points North Publications Ltd, LS1 6ER. Customer Service: 03303330320
                    </div>

                    <div style="height: 30%; width: 100%; color: white; font-size: 0.75vw; display: flex; justify-content: center; align-items: center; padding-right: 10%; padding-left: 10%">
                        Copyright © 2019 - 2020 All Points North Publications . All rights reserved.
                    </div>

                    <div style="height: 25%; width: 100%; display: flex; justify-content: center; align-items: center;">
                        <v-avatar size="25%" style="height: auto; max-width: 100%;" tile>
                            <img
                                    src="http://www.babeflirt.com/images/visa.png"
                                    alt="Visa Verified"
                            >
                        </v-avatar>
                    </div>

                </div>

            </div>

        </div>

        <div id="version-mobile">
            <div id="app">
                <div id="page-content">
                    <div id="service-selector">
                        <v-item-group
                                v-model="window"
                                class="text-center"
                                mandatory
                        >
                            <v-item
                                    v-for="n in length"
                                    :key="`btn-${n}`"
                                    v-slot:default="{ active, toggle }"
                            >
                                <v-btn
                                        x-small
                                        :input-value="active"
                                        icon
                                        color="white"
                                        @click="toggle"
                                >
                                    <v-icon style="font-size: 3vw">fas fa-circle</v-icon>
                                </v-btn>
                            </v-item>
                        </v-item-group>
                    </div>
                    <div id="profile-content">
                        <div id="profile-card">
                            <div style="display: none">
                                <v-layout v-resize="onResize">    <!--Used to dynamically resize card-->
                                </v-layout>
                            </div>
                            <v-window
                                    continuous
                                    v-model="window"
                            >
                                <v-window-item
                                        v-for="n in length"
                                        :key="n"
                                >
                                    <div id="inner-profile-card" v-bind:style="{ width: computedWidth, height: computedHeight }">
                                        <div id="card-banner">
                                            {{getBundle(n)}}
                                            <div v-bind:style="{ background: badgeColor, color: bundleTextColor, backgroundSize: badgeCover}" class="bundle-number">{{bundleText}}</div>
                                        </div>

                                        <div id="card-content">
                                            <div class="bundle-info" v-if="n == 1">
                                                <div class="bundle-info-main"> {{computedBronzeMainText}}
                                                    <div class="bundle-info-second"> {{computedSecondaryBronzeText}} </div>
                                                </div>
                                            </div>
                                            <div class="bundle-info" v-if="n == 2  ">
                                                <div class="bundle-info-main"> {{computedSilverMainText}}
                                                    <div class="bundle-info-second"> {{computedSilverSecondaryText}} </div>
                                                </div>
                                            </div>
                                            <div class="bundle-info" v-if="n == 3  ">
                                                <div class="bundle-info-main"> {{computedGoldMainText}}
                                                    <div class="bundle-info-second"> {{computedGoldSecondaryText}} </div>
                                                </div>
                                            </div>
                                            <div class="bundle-info" v-if="n == 4  ">
                                                <div class="bundle-info-main"> {{computedPlatinumMainText}}
                                                    <div class="bundle-info-second"> {{computedPlatinumSecondaryText}} </div>
                                                </div>
                                            </div>
                                            <div class="bundle-info" v-if="n == 5  ">
                                                <div class="bundle-info-main"> {{computedPromoMainText}}
                                                    <div class="bundle-info-second"> {{computedPromoSecond}} </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="card-button">
                                            <div class="paypal-section" v-if="n == 1  ">
                                                <div class="paypal-button">
                                                    <paypal-checkout v-bind:style="{ opacity: hidepaypal }"
                                                                     env="production"
                                                                     :amount="amountBronze"
                                                                     :currency="currencyCode"
                                                                     v-bind:client="paypal"
                                                                     :button-style="mystyle"
                                                                     v-on:payment-completed="processPaymentBronze"
                                                                     v-on:payment-cancelled="processFailedPayment">
                                                    </paypal-checkout>
                                                </div>
                                                <div class="payment-info-dis">
                                                    {{computedBronzeAdditionalInfo}}
                                                </div>
                                            </div>
                                            <div  class="paypal-section" v-if="n === 2">
                                                <div class="paypal-button">
                                                    <paypal-checkout v-bind:style="{ opacity: hidepaypal }"
                                                                     env="production"
                                                                     :amount="amountSilver"
                                                                     :currency="currencyCode"
                                                                     v-bind:client="paypal"
                                                                     :button-style="mystyle"
                                                                     v-on:payment-completed="processPaymentSilver"
                                                                     v-on:payment-cancelled="processFailedPayment">
                                                    </paypal-checkout>
                                                </div>
                                                <div class="payment-info-dis">
                                                    {{computedSilverAdditionalInfo}}
                                                </div>
                                            </div>
                                            <div  class="paypal-section" v-if="n === 3">
                                                <div class="paypal-button">
                                                    <paypal-checkout v-bind:style="{ opacity: hidepaypal }"
                                                                     env="production"
                                                                     :amount="amountGold"
                                                                     :currency="currencyCode"
                                                                     v-bind:client="paypal"
                                                                     :button-style="mystyle"
                                                                     v-on:payment-completed="processPaymentGold"
                                                                     v-on:payment-cancelled="processFailedPayment">
                                                    </paypal-checkout>
                                                </div>
                                                <div class="payment-info-dis">
                                                    {{computedGoldAdditionalInfo}}
                                                </div>
                                            </div>
                                            <div  class="paypal-section" v-if="n === 4">
                                                <div class="paypal-button">
                                                    <paypal-checkout v-bind:style="{ opacity: hidepaypal }"
                                                                     env="production"
                                                                     :amount="amountPlatinum"
                                                                     :currency="currencyCode"
                                                                     v-bind:client="paypal"
                                                                     :button-style="mystyle"
                                                                     v-on:payment-completed="processPaymentPlatinum"
                                                                     v-on:payment-cancelled="processFailedPayment">
                                                    </paypal-checkout>
                                                </div>
                                                <div class="payment-info-dis">
                                                    {{computedPlatinumAdditionalInfo}}
                                                </div>
                                            </div>
                                            <div  class="paypal-section" v-if="n === 5">
                                                <div class="paypal-button">
                                                    <paypal-checkout v-bind:style="{ opacity: hidepaypal }"
                                                                     env="production"
                                                                     :amount="amountPromo"
                                                                     :currency="currencyCode"
                                                                     v-bind:client="paypal"
                                                                     :button-style="mystyle"
                                                                     v-on:payment-completed="processPaymentPromo"
                                                                     v-on:payment-cancelled="processFailedPayment">
                                                    </paypal-checkout>
                                                </div>
                                                <div class="payment-info-dis">
                                                    {{computedPromoAdditionalInfo}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </v-window-item>
                            </v-window>
                        </div>
                    </div>
                    <div id="logo-area">
                        <div class="logo-image-holder" v-bind:style="{backgroundImage: computedGirlTextLogo}"></div>
                        <div class="logo-image-holder" style="  filter: brightness(0) invert(1);" v-bind:style="{backgroundImage: computedChatTubeLogo}"></div>
                        <div class="logo-image-holder" style="  filter: brightness(0) invert(1);" v-bind:style="{backgroundImage: computedBabeFlirtLogo}"></div>
                        <div class="logo-image-holder" v-bind:style="{backgroundImage: computedGayTextLogo}"></div>
                    </div>
                </div>
            </div>

            <v-overlay v-hammer:tap="closeOverlay"
                       opacity="0.8"
                       :value="overlay">
                <div id="overlay-body">
                    <div class="content-content-text-area">
                        <p class="content-text" >Bundle Controls</p>
                        <p class="content-text-2" >Swipe left or right to see available payment bundles </p>
                    </div>
                    <div class="content-animation-area">
                        <v-icon color="rgba(255,255,255,0.7" id="phone-animation">fas fa-mobile</v-icon>
                        <br>
                        <v-icon color="rgba(255,255,255,1" id="finger-animation">fas fa-hand-point-up</v-icon>
                    </div>
                </div>
            </v-overlay>

            <v-overlay
                    opacity="0.9"
                    color="black"
                    :value="paymentSuccessOverlay">

                <div style="width: 100vw; height: 100vh">

                <v-btn v-if="showPaymentSuccess == false"
                       style="position: absolute; top: 2%; right: 2%"
                       icon
                       absolute
                       color="white"
                       @click="paymentSuccessOverlay = false; showPaymentSuccess = true; hidepaypal = 1"
                >
                    <v-icon>fas fa-times</v-icon>
                </v-btn>
                    <v-fade-transition>
                <div id="payment-loading" v-if="showPaymentSuccess">
                    <div style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center">
                        <v-progress-circular
                                size="175"
                                width="10"
                                color="#FFFFFF"
                                indeterminate
                        >
                            <div style="font-size: 3vw; font-weight: bold">Processing Payment</div>
                        </v-progress-circular>
                    </div>
                </div>
                <div id="payment-success-modal" v-else>
                    <div v-if="showPaymentSuccessState" style="width: 100%; height: 50%;">
                        <div style="height: 30%; width: 100%; display: flex; justify-content: center; align-items: center">

                            <v-icon style="font-size: 12.5vh" color="green">
                                fas fa-check-circle
                            </v-icon>

                        </div>
                        <div id="payment-success-header">
                            Payment Successful
                        </div>
                        <div id="payment-success-content">
                            <div id="content-top">
                                Order number: <b style="padding-left: 1vw">{{transactionNumberToUser}}</b>
                            </div>
                            <div id="content-middle">
                                Please give us up to an hour to credit your account
                            </div>
                            <div id="content-bottom">
                                For any inquiries <br> please do not hesitate and contact us on
                            </div>
                            <div id="content-number">
                                <b>{{regionCustomerCare}}</b>
                            </div>
                            <br>
                        </div>
                        <div id="payment-success-footer">
                    </div>
                    </div>

                    <div v-else style="width: 100%; height: 50%;">
                        <div style="height: 30%; width: 100%; display: flex; justify-content: center; align-items: center">
                            <v-icon style="font-size: 12.5vh" color="red">
                                fas fa-times-circle
                            </v-icon>
                        </div>
                        <div id="payment-success-header">
                            Oops!
                        </div>
                        <div id="content-top">
                            Payment was unsuccessful
                            <br>
                            Please Try Again
                        </div>
                        <div>
                        </div>
                    </div>

                </div>
                    </v-fade-transition>
                </div>
            </v-overlay>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Vuetify from 'vuetify'
    import 'vuetify/dist/vuetify.min.css'
    import { AXIOS } from '../../http-common'
    import PayPal from 'vue-paypal-checkout'
    Vue.component('paypal-checkout', PayPal)
    Vue.use(Vuetify)
    export default {

        // Props are data sent from landing pages
        props: [
            'serviceIdSelected', 'telephoneNumberEntered'
        ],
        data () {
            return {
                showPaymentSuccessState: "",
                e1:"",
                processingPayment: false,

                desktopOverlayState:"",


                showDynamicBadge:'',
                desktopPrePurchaseBundleIdPromo:'',
                desktopPrePurchaseBundleId:'',
                desktopPrePurchaseBundleTitle:'',
                bundleDesktopIdentifier:'',
                desktopAdditionalInfo:'',

                desktopOverlay: false,

                eligableBronzeFreeCredit: '',
                eligableSilverFreeCredit: '',
                eligableGoldFreeCredit: '',
                eligablePlatinumFreeCredit: '',

                eligableBronzeFreeCreditUK: '',
                eligableSilverFreeCreditUK: '',
                eligableGoldFreeCreditUK: '',
                eligablePlatinumFreeCreditUK: '',

                bronzeBundle: {},
                silverBundle: {},
                goldBundle: {},
                platinumBundle: {},

                bronzeUkPayment: '',
                bronzeAsPayment: '',
                bronzeUkCredit: '',
                bronzeAsCredit: '',

                silverUkPayment: '',
                silverAsPayment: '',
                silverUkCredit: '',
                silverAsCredit: '',

                goldUkPayment: '',
                goldAsPayment: '',
                goldUkCredit: '',
                goldAsCredit: '',

                platinumUkPayment: '',
                platinumAsPayment: '',
                platinumUkCredit: '',
                platinumAsCredit: '',

                // Logos Start
                logoChatTube: require('@/images/logos/chatTube.png'),
                logoBabeFlirt: require('@/images/logos/babeflirt.png'),
                logoGayTxt: require('@/images/logos/gayText.png'),
                logoGirlTxtW: require('@/images/logos/girlTextW.png'),
                // Logos End

                // Bundle Payments Start
                creditBronze: '',
                creditSilver: '',
                creditGold: '',
                creditPlatinum: '',
                creditPromo: '',
                creditToReceive:'',

                amountSelected:'',

                amountBronze: '',
                amountSilver: '',
                amountGold: '',
                amountPlatinum: '',
                amountPromo: '',
                currencyCode: '',
                freeCredits: '',
                // Bundle Payments End
                head: {
                    script: [
                        { src: 'https://unpkg.com/vue-paypal-checkout@2.0.0/dist/vue-paypal-checkout.min.js' }
                    ]
                }, // Inserts paypal script
                // PayPal Button Start
                // Button style
                mystyle: {
                    label: 'checkout',
                    size: 'responsive',
                    shape: 'rect',
                    color: 'gold'
                },
                // PayPal enviroment ids
                paypal: {
                    sandbox: 'AT0S4X1EvCZmUn9hot14IqtbjME6EY8or-pAqOEhpgijk1fX-U1QlUQNHq2Ydqb8q3FQ9xL8ng8srJwi',
                    production: 'AQQsbinGxMRXPhvJ5_oJCXuQ_w9ENOqPSI6MxIhzPfN2cNM-Cmmfht6WBKdrtaHIfUABfHzsXn05Si_E'
                },
                // PayPal Button End
                // Promo Notification Start
                snackbarText: '',
                snackbarIcon: '',
                snackbarColor: '',
                alertActive: false,
                // Promo Notification End
                // Dynamic Size Start
                width: '100px',
                height: '100px',
                windowSize: {
                    x: 0,
                    y: 0
                },
                // Dynamic Size End
                // Window tools Start
                length: '',
                window: '',
                // Window tool end
                // Dynamic Page Start
                logoBabeFlirt: require('../../images/logos/babeflirt.png'),
                babeFlirtBackgroundM: require('../../images/backgrounds/babeflirtM.jpg'),
                // Dynamic Page End
                regionCustomerCare: '', // Telephone number for UK or AUS customers
                showPaymentSuccess: true, // Overlay loader for successful payment
                paymentSuccessOverlay: false, // Overlay for successful payment
                transactionNumberToUser: '', // Shows the order number of their payment
                hidepaypal: false, // Used for styling purposes to mask paypal button when overlay is active
                overlay: false, // The manual overlay ;)
                customerRegion: '' // defines users region
            }
        },

        computed: {
            // Computes Chat Tube Logo
            computedChatTubeLogo: function () {
                this.logoChatTube = 'url(' + this.logoChatTube + ')'
                return this.logoChatTube
            },
            // Computes Girl Text Logo
            computedGirlTextLogo: function () {
                this.logoGirlTxtW = 'url(' + this.logoGirlTxtW + ')'
                return this.logoGirlTxtW
            },
            // Computes Babe flirt Logo
            computedBabeFlirtLogo: function () {
                this.logoBabeFlirt = 'url(' + this.logoBabeFlirt + ')'
                return this.logoBabeFlirt
            },
            // Computes Gay Text Logo
            computedGayTextLogo: function () {
                this.logoGayTxt = 'url(' + this.logoGayTxt + ')'
                return this.logoGayTxt
            },
            computedBronzeMainText: function () {
                if (this.customerRegion == 1) {
                    var bronzeText = 'Get £' + this.creditBronze + ' service credits for only £' + this.amountBronze + ' with the Bronze Pack!'
                } else if (this.customerRegion == 2) {
                    var bronzeText = 'Get ' + this.creditBronze + ' service credits for only $' + this.amountBronze + ' with the Bronze Pack!'
                }
                return bronzeText
            },
            computedSecondaryBronzeText: function () {
                if (this.customerRegion == 1 && this.eligableBronzeFreeCreditUK == true) {
                    var bronzeTextSecondary = 'You will receive £' + this.freeBronzeCreditsUk + ' FREE credit to use on this service.'
                } else if (this.customerRegion == 1 && this.eligableBronzeFreeCreditUK == false){
                    var bronzeTextSecondary = ''
                } else if (this.customerRegion == 2 && this.eligableBronzeFreeCredit == true) {
                    var bronzeTextSecondary = 'You will receive ' + this.freeBronzeCreditsAus + ' FREE credit to use on this service.'
                } else if (this.customerRegion == 2 && this.eligableBronzeFreeCredit == false) {
                    var bronzeTextSecondary = ''
                }
                return bronzeTextSecondary
            },

            computedBronzeAdditionalInfo: function () {
                if (this.customerRegion == 1) {
                    var additionalBronzeText = 'By purchasing this package we will credit your account with us with £' + this.creditBronze + ' credit. Charges: 50p to msg a user, 10p to receive user profile, £1.00 for 3 user photos + standard network for all inbound messages. '
                } else if (this.customerRegion == 2) {
                    var additionalBronzeText = 'By purchasing this package we will credit your account with us with ' + this.creditBronze + ' credit. Charges: 1 credit to msg a user, 1 credit for 3 user photos + $0.25 standard message fee for all inbound messages.'
                }
                return additionalBronzeText
            },

            computedSilverMainText: function () {
                if (this.customerRegion == 1) {
                    var silverMain = 'Get £' + this.creditSilver + ' service credits for only £' + this.amountSilver + ' with the Silver Pack!'
                } else if (this.customerRegion == 2) {
                    var silverMain = 'Get ' + this.creditSilver + ' service credits for only $' + this.amountSilver + ' with the Silver Pack!'
                }
                return silverMain
            },

            computedSilverSecondaryText: function () {
                if (this.customerRegion == 1 && this.eligableSilverFreeCreditUK == true) {
                    var silverSecond = 'You will receive £' + this.freeSilverCreditsUk + ' FREE credit to use on this service.'
                } else if (this.customerRegion == 1 && this.eligableSilverFreeCreditUK == false) {
                    var silverSecond = ''
                } else if (this.customerRegion == 2 && this.eligableSilverFreeCredit == true) {
                    var silverSecond = 'You will receive ' + this.freeSilverCreditsAus + ' FREE credit to use on this service.'
                } else if (this.customerRegion == 2 && this.eligableSilverFreeCredit == false) {
                    var silverSecond = ''
                }
                return silverSecond
            },

            computedSilverAdditionalInfo: function () {
                if (this.customerRegion == 1) {
                    var silverAdditional = 'By purchasing this package we will credit your account with us with £' + this.creditSilver + ' credit. Charges: 50p to msg a user, 10p to receive user profile, £1.00 for 3 user photos + standard network for all inbound messages. '
                } else if (this.customerRegion == 2) {
                    var silverAdditional = 'By purchasing this package we will credit your account with us with ' + this.creditSilver + ' credit. Charges: 1 credit to msg a user, 1 credit for 3 user photos + $0.25 standard message fee for all inbound messages.'
                }
                return silverAdditional
            },

            computedGoldMainText: function () {
                if (this.customerRegion == 1) {
                    var goldMain = 'Get £' + this.creditGold + ' service credits for only £' + this.amountGold + ' with the Gold Pack!'
                } else if (this.customerRegion == 2) {
                    var goldMain = 'Get ' + this.creditGold + ' service credits for only $' + this.amountGold + ' with the Gold Pack!'
                }
                return goldMain
            },

            computedGoldSecondaryText: function () {
                if (this.customerRegion == 1 && this.eligableGoldFreeCreditUK == true) {
                    var secondGold = 'You will receive £' + this.freeGoldCreditsUk + ' FREE credit to use on this service.'
                } else if (this.customerRegion == 1 && this.eligableGoldFreeCreditUK == false) {
                    var secondGold = ''
                } else if (this.customerRegion == 2 && this.eligableGoldFreeCredit == true) {
                    var secondGold = 'You will receive ' + this.freeGoldCreditsAus + ' FREE credit to use on this service.'
                } else if (this.customerRegion == 2 && this.eligableGoldFreeCredit == false) {
                    var secondGold = ''
                }
                return secondGold
            },

            computedGoldAdditionalInfo: function () {
                if (this.customerRegion == 1) {
                    var goldAdditional = 'By purchasing this package we will credit your account with us with £' + this.creditGold + ' credit. Charges: 50p to msg a user, 10p to receive user profile, £1.00 for 3 user photos + standard network for all inbound messages. '
                } else if (this.customerRegion == 2) {
                    var goldAdditional = 'By purchasing this package we will credit your account with us with ' + this.creditGold + ' credit. Charges: 1 credit to msg a user, 1 credit for 3 user photos + $0.25 standard message fee for all inbound messages.'
                }
                return goldAdditional
            },

            computedPlatinumMainText: function () {
                if (this.customerRegion == 1) {
                    var platinumText = 'Get £' + this.creditPlatinum + ' service credits for only £' + this.amountPlatinum + ' with the Platinum Pack!'
                } else if (this.customerRegion == 2) {
                    var platinumText = 'Get ' + this.creditPlatinum + ' service credits for only $' + this.amountPlatinum + ' with the Platinum Pack!'
                }
                return platinumText
            },

            computedPlatinumSecondaryText: function () {
                if (this.customerRegion == 1 && this.eligablePlatinumFreeCreditUK == true) {
                    var secondPlat = 'You will receive £' + this.freePlatinumCreditsUk + ' FREE credit to use on this service.'
                } else if (this.customerRegion == 1 && this.eligablePlatinumFreeCreditUK == false) {
                    var secondPlat = ''
                } else if (this.customerRegion == 2 && this.eligablePlatinumFreeCredit == true) {
                    var secondPlat = 'You will receive ' + this.freePlatinumCreditsAus + ' FREE credit to use on this service.'
                } else if (this.customerRegion == 2 && this.eligablePlatinumFreeCredit == false) {
                    var secondPlat = ''
                }
                return secondPlat
            },

            computedPlatinumAdditionalInfo: function () {
                if (this.customerRegion == 1) {
                    var platinumAdditional = 'By purchasing this package we will credit your account with us with £' + this.creditPlatinum + ' credit. Charges: 50p to msg a user, 10p to receive user profile, £1.00 for 3 user photos + standard network for all inbound messages. '
                } else if (this.customerRegion == 2) {
                    var platinumAdditional = 'By purchasing this package we will credit your account with us with ' + this.creditPlatinum + ' credit. Charges: 1 credit to msg a user, 1 credit for 3 user photos + $0.25 standard message fee for all inbound messages.'
                }
                return platinumAdditional
            },

            computedPromoMainText: function () {
                if (this.customerRegion == 1) {
                    var promoMain = 'Get £' + this.bundleData.creditUk + ' service credits for only £' + this.bundleData.amountUk + ' with the ' + this.bundleData.promoName + ' Promo Pack!'
                } else if (this.customerRegion == 2) {
                    var promoMain = 'Get ' + this.bundleData.creditAs + ' service credits for only $' + this.bundleData.amountAs + ' with the ' + this.bundleData.promoName + ' Promo Pack!'
                }
                return promoMain
            },

            computedPromoSecond: function () {
                if (this.customerRegion == 1) {
                    var promoSecondary = 'You will receive £' + this.freeCredits + ' FREE credit to use on this service.'
                } else if (this.customerRegion == 2) {
                    var promoSecondary = ''
                }
                return promoSecondary
            },

            computedPromoAdditionalInfo: function () {
                if (this.customerRegion == 1) {
                    var promoInfo = 'By purchasing this package we will credit your account with us with £' + this.bundleData.creditUk + ' credit. Charges: 50p to msg a user, 10p to receive user profile, £1.00 for 3 user photos + standard network for all inbound messages. '
                } else if (this.customerRegion == 2) {
                    var promoInfo = 'By purchasing this package we will credit your account with us with ' + this.bundleData.creditAs + ' credit. Charges: 1 credit to msg a user, 1 credit for 3 user photos + $0.25 standard message fee for all inbound messages.'
                }
                return promoInfo
            },

            // Computes The width of the card
            computedWidth: function () {
                return this.width
            },
            // Computes The height of the card
            computedHeight: function () {
                return this.height
            }

        },

        watch: {



            // Looks if notification is active if it is then turn off after 3 seconds
            alertActive: function (val) {
                if (val == true) {
                    setTimeout(() => this.alertActive = false, 3000)
                }
            }
        },

        created() {



            setInterval(this.checkIfPayPalZoidIsOpen, 1000)

        },

        methods: {

            processFailedPayment(){
                this.e1 = 4
                setTimeout(() => this.showPaymentSuccess = false, 1000)
                this.showPaymentSuccessState = false
            },

            checkIfPayPalZoidIsOpen(){
                if (document.querySelector('[id^="zoid-paypal-checkout-"]') == null && this.processingPayment == false) {

                }
                else {
                    this.e1 = 1
                    this.hidepaypal = 0.5
                    this.paymentSuccessOverlay = true
                }
            },

            processPayment(data){

                this.processingPayment = true

                if (data.state == "approved"){

                    if (data.transactions[0].amount.total == this.amountBronze + ".00"){
                        this.processPaymentBronze(data)
                    }
                    else if (data.transactions[0].amount.total == this.amountSilver + ".00"){
                        this.processPaymentSilver(data)
                    }
                    else if (data.transactions[0].amount.total == this.amountGold + ".00"){
                        this.processPaymentGold(data)
                    }
                    else if (data.transactions[0].amount.total == this.amountPlatinum + ".00"){
                        this.processPaymentPlatinum(data)
                    }
                    else if (data.transactions[0].amount.total == this.amountPromo + ".00"){
                      this.processPaymentPromo(data)
                    }
                    else {

                    }
                }
                else {

                }

            },

            purchasePayPalDesktop (s) {

                this.e1 = 2

                this.desktopOverlayState = 1
                this.desktopAdditionalInfo = s
                this.bundleDesktopIdentifier = s

                if (s == 1){
                    this.showDynamicBadge = false
                    this.amountSelected = this.amountBronze
                    this.creditToReceive = this.creditBronze
                    this.desktopPrePurchaseBundleId = "bronze-background"
                    this.desktopPrePurchaseBundleTitle = "Bronze"
                }
                else if (s == 2){
                    this.showDynamicBadge = false
                    this.amountSelected = this.amountSilver
                    this.creditToReceive = this.creditSilver
                    this.desktopPrePurchaseBundleId = "silver-background"
                    this.desktopPrePurchaseBundleTitle = "Silver"
                }

                else if (s == 3){
                    this.showDynamicBadge = false
                    this.amountSelected = this.amountGold
                    this.creditToReceive = this.creditGold
                    this.desktopPrePurchaseBundleId = "gold-background"
                    this.desktopPrePurchaseBundleTitle = "Gold"
                }

                else if (s == 4){
                    this.showDynamicBadge = false
                    this.amountSelected = this.amountPlatinum
                    this.creditToReceive = this.creditPlatinum
                    this.desktopPrePurchaseBundleId = "platinum-background"
                    this.desktopPrePurchaseBundleTitle = "Platinum"
                }

                else if (s == 5){
                    this.showDynamicBadge = true
                    this.amountSelected = this.amountPromo
                    this.creditToReceive = this.creditPromo
                    this.desktopPrePurchaseBundleIdPromo = this.bundleData.badgeBackground
                    this.desktopPrePurchaseBundleTitle = this.bundleData.bundleName
                }


                this.desktopOverlay = true


            },

            // Closes the overlay gives paypal button its normal opacity
            closeOverlay () {
                this.overlay = !this.overlay
                this.hidepaypal = 1
            },

            // Simple maths function calculates how much free credits will be given to customer (UK only)
            calculatePromoFreeCredits () {
                this.freeCredits = this.creditPromo - this.amountPromo
            },

            calculateFreeCredits () {
                this.freeBronzeCreditsUk = this.creditBronze - this.amountBronze
                this.freeSilverCreditsUk = this.creditSilver - this.amountSilver
                this.freeGoldCreditsUk = this.creditGold - this.amountGold
                this.freePlatinumCreditsUk = this.creditPlatinum - this.amountPlatinum

                if (this.freeBronzeCreditsUk <= 0){ this.eligableBronzeFreeCreditUK = false }
                else { this.eligableBronzeFreeCreditUK = true }

                if (this.freeSilverCreditsUk <= 0){ this.eligableSilverFreeCreditUK = false }
                else { this.eligableSilverFreeCreditUK = true }

                if (this.freeGoldCreditsUk <= 0){ this.eligableGoldFreeCreditUK = false }
                else { this.eligableGoldFreeCreditUK = true }

                if (this.freePlatinumCreditsUk <= 0){ this.eligablePlatinumFreeCreditUK = false}
                else { this.eligablePlatinumFreeCreditUK = true}
            },

            calculateFreeCreditsAus () {
                var oneCreditCost = 0.67

                var creditsForAmountGivenBronze = this.amountBronze / oneCreditCost
                var creditsForAmountGivenBronze = creditsForAmountGivenBronze.toFixed(0)
                var freeCreditsYouGetBronze = this.creditBronze - creditsForAmountGivenBronze
                var freeCreditsYouGetBronze = freeCreditsYouGetBronze.toFixed(0)
                var freeCreditsYouGetBronze = 5 * Math.round(freeCreditsYouGetBronze / 5)

                if (freeCreditsYouGetBronze != 0) {
                    this.freeBronzeCreditsAus = freeCreditsYouGetBronze
                    this.eligableBronzeFreeCredit = true
                } else {
                    this.eligableBronzeFreeCredit = false
                }

                var creditsForAmountGivenSilver = this.amountSilver / oneCreditCost
                var creditsForAmountGivenSilver = creditsForAmountGivenSilver.toFixed(0)
                var freeCreditsYouGetSilver = this.creditSilver - creditsForAmountGivenSilver
                var freeCreditsYouGetSilver = freeCreditsYouGetSilver.toFixed(0)
                var freeCreditsYouGetSilver = 5 * Math.round(freeCreditsYouGetSilver / 5)

                if (freeCreditsYouGetSilver != 0) {
                    this.freeSilverCreditsAus = freeCreditsYouGetSilver
                    this.eligableSilverFreeCredit = true
                } else {
                    this.eligableSilverFreeCredit = false
                }

                var creditsForAmountGivenGold = this.amountGold / oneCreditCost
                var creditsForAmountGivenGold = creditsForAmountGivenGold.toFixed(0)
                var freeCreditsYouGetGold = this.creditGold - creditsForAmountGivenGold
                var freeCreditsYouGetGold = freeCreditsYouGetGold.toFixed(0)
                var freeCreditsYouGetGold = 5 * Math.round(freeCreditsYouGetGold / 5)

                if (freeCreditsYouGetGold != 0) {
                    this.freeGoldCreditsAus = freeCreditsYouGetGold
                    this.eligableGoldFreeCredit = true
                } else {
                    this.eligableGoldFreeCredit = false
                }

                var creditsForAmountGivenPlatinum = this.amountPlatinum / oneCreditCost
                var creditsForAmountGivenPlatinum = creditsForAmountGivenPlatinum.toFixed(0)
                var freeCreditsYouGetPlatinum = this.creditPlatinum - creditsForAmountGivenPlatinum
                var freeCreditsYouGetPlatinum = freeCreditsYouGetPlatinum.toFixed(0)
                var freeCreditsYouGetPlatinum = 5 * Math.round(freeCreditsYouGetPlatinum / 5)

                if (freeCreditsYouGetPlatinum != 0) {
                    this.freePlatinumCreditsAus = freeCreditsYouGetPlatinum
                    this.eligablePlatinumFreeCredit = true
                } else {
                    this.eligablePlatinumFreeCredit = false
                }
            },

            // Checks Bundle Prices
            getBundles () {
                AXIOS({
                    method: 'GET',
                    url: '/api/bundle'
                })
                    .then(response => {
                        this.bronzeBundle = response.data.filter(kp6 => kp6.id === 1)
                        this.silverBundle = response.data.filter(kp6 => kp6.id === 2)
                        this.goldBundle = response.data.filter(kp6 => kp6.id === 3)
                        this.platinumBundle = response.data.filter(kp6 => kp6.id === 4)

                        this.bronzeUkPayment = this.bronzeBundle[0].amountUk.toString()

                        this.bronzeAsPayment = this.bronzeBundle[0].amountAs.toString()
                        this.bronzeUkCredit = this.bronzeBundle[0].creditUk.toString()
                        this.bronzeAsCredit = this.bronzeBundle[0].creditAs.toString()

                        this.silverUkPayment = this.silverBundle[0].amountUk.toString()
                        this.silverAsPayment = this.silverBundle[0].amountAs.toString()
                        this.silverUkCredit = this.silverBundle[0].creditUk.toString()
                        this.silverAsCredit = this.silverBundle[0].creditAs.toString()

                        this.goldUkPayment = this.goldBundle[0].amountUk.toString()
                        this.goldAsPayment = this.goldBundle[0].amountAs.toString()
                        this.goldUkCredit = this.goldBundle[0].creditUk.toString()
                        this.goldAsCredit = this.goldBundle[0].creditAs.toString()

                        this.platinumUkPayment = this.platinumBundle[0].amountUk.toString()
                        this.platinumAsPayment = this.platinumBundle[0].amountAs.toString()
                        this.platinumUkCredit = this.platinumBundle[0].creditUk.toString()
                        this.platinumAsCredit = this.platinumBundle[0].creditAs.toString()

                        this.checkServiceId() // On load check the service Id
                        this.calculateFreeCredits()
                        this.calculateFreeCreditsAus()
                    })
            },

            // Checks if there is a promo bundle
            checkPromoBundle () {
                AXIOS({
                    method: 'GET',
                    url: '/api/promo'
                })
                    .then(response => {
                        this.bundleResponse = response.data[0].active // assigns bundle active
                        this.bundleData = response.data[0] // Bundle data
                        if (this.bundleResponse == true) {
                            this.length = 5
                            this.window = 4
                            // Look at user service id and assign values accordingly
                            if (this.serviceIdSelected == 1 || this.serviceIdSelected == 2) {
                                this.amountPromo = this.bundleData.amountUk.toString()
                                this.creditPromo = this.bundleData.creditUk.toString()
                            } else if (this.serviceIdSelected == 3) {
                                this.amountPromo = this.bundleData.amountAs.toString()
                                this.creditPromo = this.bundleData.creditAs.toString()
                            }
                            this.calculatePromoFreeCredits() // Calculates how much free credits there are to give to uk promo
                        } else {
                            // if no promo bundle display only 4 show page 0.
                            this.length = 4
                            this.window = 0
                        }
                    })
            },

            checkServiceId () {
                if (this.serviceIdSelected == 1 || this.serviceIdSelected == 2) {
                    this.customerRegion = 1
                    this.amountBronze = this.bronzeUkPayment
                    this.amountSilver = this.silverUkPayment
                    this.amountGold = this.goldUkPayment
                    this.amountPlatinum = this.platinumUkPayment
                    this.creditBronze = this.bronzeUkCredit
                    this.creditSilver = this.silverUkCredit
                    this.creditGold = this.goldUkCredit
                    this.creditPlatinum = this.platinumUkCredit
                    this.currencyCode = 'GBP'
                    this.regionCustomerCare = '03303330320'
                } else if (this.serviceIdSelected == 3) {
                    this.customerRegion = 2
                    this.amountBronze = this.bronzeAsPayment
                    this.amountSilver = this.silverAsPayment
                    this.amountGold = this.goldAsPayment
                    this.amountPlatinum = this.platinumAsPayment
                    this.creditBronze = this.bronzeAsCredit
                    this.creditSilver = this.silverAsCredit
                    this.creditGold = this.goldAsCredit
                    this.creditPlatinum = this.platinumAsCredit
                    this.currencyCode = 'AUD'
                    this.regionCustomerCare = '0477769766'
                }
            },

            processPaymentBronze: function (data) {
                AXIOS({
                    method: 'POST',
                    url: 'api/order/',
                    data: {
                        serviceId: this.serviceIdSelected,
                        telephoneNumber: this.telephoneNumberEntered,
                        amount: data.transactions[0].amount.total,
                        credit: this.creditBronze,
                        creditProcessed: 0,
                        customerPayPalId: data.payer.payer_info.payer_id,
                        paymentCurrency: data.transactions[0].amount.currency,
                        payPalCaptureTime: data.create_time,
                        transactionId: data.transactions[0].related_resources[0].sale.id,
                        orderNumber: data.cart,
                        processTime: null,
                        refund: false
                    }
                })
                    .then(response => {
                        this.transactionNumberToUser = data.transactions[0].related_resources[0].sale.id
                        this.paymentSuccessOverlay = true
                        this.showPaymentSuccess = true
                        setTimeout(() => this.showPaymentSuccess = false, 1000)
                        this.showPaymentSuccessState = true

                        this.hidepaypal = 0.5
                        this.e1 = 3
                        this.processingPayment = false

                    },
                        (err) => {
                        this.processFailedPayment()
                        }
                    )
            },

            processPaymentSilver: function (data) {
                AXIOS({
                    method: 'POST',
                    url: 'api/order/',
                    data: {
                        serviceId: this.serviceIdSelected,
                        telephoneNumber: this.telephoneNumberEntered,
                        amount: data.transactions[0].amount.total,
                        credit: this.creditSilver,
                        creditProcessed: 0,
                        customerPayPalId: data.payer.payer_info.payer_id,
                        paymentCurrency: data.transactions[0].amount.currency,
                        payPalCaptureTime: data.create_time,
                        transactionId: data.transactions[0].related_resources[0].sale.id,
                        orderNumber: data.cart,
                        processTime: null,
                        refund: false
                    }
                })
                    .then(response => {
                        this.transactionNumberToUser = data.transactions[0].related_resources[0].sale.id
                        this.paymentSuccessOverlay = true
                        this.showPaymentSuccess = true
                        setTimeout(() => this.showPaymentSuccess = false, 1000)
                            this.showPaymentSuccessState = true
                        this.hidepaypal = 0.5
                        this.e1 = 3
                        this.processingPayment = false
                    },
                        (err) => {
                            this.processFailedPayment()
                        }
                        )

            },
            processPaymentGold: function (data) {
                AXIOS({
                    method: 'POST',
                    url: 'api/order/',
                    data: {
                        serviceId: this.serviceIdSelected,
                        telephoneNumber: this.telephoneNumberEntered,
                        amount: data.transactions[0].amount.total,
                        credit: this.creditGold,
                        creditProcessed: 0,
                        customerPayPalId: data.payer.payer_info.payer_id,
                        paymentCurrency: data.transactions[0].amount.currency,
                        payPalCaptureTime: data.create_time,
                        transactionId: data.transactions[0].related_resources[0].sale.id,
                        orderNumber: data.cart,
                        processTime: null,
                        refund: false
                    }
                })
                    .then(response => {
                        this.transactionNumberToUser = data.transactions[0].related_resources[0].sale.id
                        this.paymentSuccessOverlay = true
                        this.showPaymentSuccess = true
                        setTimeout(() => this.showPaymentSuccess = false, 1000)
                            this.showPaymentSuccessState = true
                        this.hidepaypal = 0.5
                        this.e1 = 3
                        this.processingPayment = false
                    },
                        (err) => {
                            this.processFailedPayment()
                        }
                    )
            },
            processPaymentPlatinum: function (data) {
                AXIOS({
                    method: 'POST',
                    url: 'api/order/',
                    data: {
                        serviceId: this.serviceIdSelected,
                        telephoneNumber: this.telephoneNumberEntered,
                        amount: data.transactions[0].amount.total,
                        credit: this.creditPlatinum,
                        creditProcessed: 0,
                        customerPayPalId: data.payer.payer_info.payer_id,
                        paymentCurrency: data.transactions[0].amount.currency,
                        payPalCaptureTime: data.create_time,
                        transactionId: data.transactions[0].related_resources[0].sale.id,
                        orderNumber: data.cart,
                        processTime: null,
                        refund: false
                    }
                })
                    .then(response => {
                        this.transactionNumberToUser = data.transactions[0].related_resources[0].sale.id
                        this.paymentSuccessOverlay = true
                        this.showPaymentSuccess = true
                        setTimeout(() => this.showPaymentSuccess = false, 1000)
                            this.showPaymentSuccessState = true
                        this.hidepaypal = 0.5
                        this.e1 = 3
                        this.processingPayment = false
                    },
                        (err) => {
                            this.processFailedPayment()
                        }
                    )
            },
            processPaymentPromo: function (data) {
                AXIOS({
                    method: 'POST',
                    url: 'api/order/',
                    data: {
                        serviceId: this.serviceIdSelected,
                        telephoneNumber: this.telephoneNumberEntered,
                        amount: data.transactions[0].amount.total,
                        credit: this.creditPromo,
                        creditProcessed: 0,
                        customerPayPalId: data.payer.payer_info.payer_id,
                        paymentCurrency: data.transactions[0].amount.currency,
                        payPalCaptureTime: data.create_time,
                        transactionId: data.transactions[0].related_resources[0].sale.id,
                        orderNumber: data.cart,
                        processTime: null,
                        refund: false
                    }
                })
                    .then(response => {
                        this.transactionNumberToUser = data.transactions[0].related_resources[0].sale.id
                        this.paymentSuccessOverlay = true
                        this.showPaymentSuccess = true
                        setTimeout(() => this.showPaymentSuccess = false, 1000)
                            this.showPaymentSuccessState = true
                        this.hidepaypal = 0.5
                        this.e1 = 3
                        this.processingPayment = false
                    },
                        (err) => {
                            this.processFailedPayment()
                        }
                    )
            },
            getBundle (n) {
                // Assigns styling to the bundle main badge
                if (n == 1) {
                    this.bundleText = 'Bronze'
                    this.bundleTextColor = 'white'
                    this.badgeColor = 'radial-gradient(ellipse farthest-corner at right top, #FFFFFF 0%, #e1b384 8%, #d7995b 25%, #905923 82.5%, #a46628 100%)'
                    this.badgeCover = ''
                } else if (n == 2) {
                    this.bundleText = 'Silver'
                    this.bundleTextColor = 'white'
                    this.badgeColor = 'radial-gradient(ellipse farthest-corner at right top, #FFFFFF 0%, #b3b3b3 8%, #999999 25%, #404040 82.5%, #4d4d4d 100%)'
                    this.badgeCover = ''
                } else if (n == 3) {
                    this.bundleText = 'Gold'
                    this.bundleTextColor = 'white'
                    this.badgeColor = 'radial-gradient(ellipse farthest-corner at right top, #FFFFFF 0%, #FFFFAC 8%, #D1B464 25%, #5d4a1f 82.5%, #5d4a1f 100%)'
                    this.badgeCover = ''
                } else if (n == 4) {
                    this.bundleText = 'Platinum'
                    this.bundleTextColor = 'white'
                    this.badgeColor = 'radial-gradient(ellipse farthest-corner at right top, #e5e4e2 0%, #e5e4e2 8%, #e5e4e2 25%, #aaa7a1 82.5%, #5e5b55 100%)'
                    this.badgeCover = ''
                } else if (n == 5) {
                    this.bundleText = this.bundleData.bundleName
                    this.bundleTextColor = this.bundleData.badgeTextColor
                    this.badgeColor = this.bundleData.badgeBackground
                    this.badgeCover = 'cover'
                }
            },
            // Reads the width and height of the profile-card div and assigns them to width and height, then applied by computed.
            onResize () {
                this.windowSize = { x: document.getElementById('profile-card').clientWidth, y: document.getElementById('profile-card').clientHeight }
                this.width = this.windowSize.x + 'px'
                this.height = this.windowSize.y + 'px'
            }
        },
        mounted () {
            this.getBundles()
            // this.checkServiceId(); //On load check the service Id
            this.checkPromoBundle() // On load check if promo bundle is active
            // Show manual overlay and apply opacity to paypal button (workaround)
            setTimeout(() => this.overlay = true, 1000)
            setTimeout(() => this.overlay = false, 5500)
            setTimeout(() => this.hidepaypal = 0.5, 1000)
            setTimeout(() => this.hidepaypal = 1, 5500)
        }
    }
</script>

<style scoped>

    html, body {
        height: 100%;
        margin: 0;
    }

    #application-page{

        height: 100%;
        width: 100%;
        margin: 0;

    }

    @media only screen and (min-width: 768px) {
        #version-desktop {
            width: 100%;
            height: 100%;
        }

        #version-mobile {
            display: none;
        }
    }


    @media only screen and (max-width: 768px) {

        #version-desktop {
            display: none;
        }
        #version-mobile {
            width: 100%;
            height: 100%;
        }
    }

    #desktop-app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        text-align: center;
        color: black;
        margin: 0;

        background: linear-gradient(to top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 59%, rgba(0, 0, 0, 0.75) 100%), url('../../images/backgrounds/babeflirtD.jpg') no-repeat;

        width: 100%;
        height: 100%;
        background-size: cover;

    }




    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        text-align: center;
        color: black;
        margin: 0;

        background: linear-gradient(to top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 59%, rgba(0, 0, 0, 0.75) 100%), url('../../images/backgrounds/babeflirtM.jpg') no-repeat;

        width: 100%;
        height: 100%;
        background-size: cover;

    }

    /*Content*/

    #page-content {
        width: 100%;
        height: 100%;

    }

    .payment-info-dis {
        font-size: 50%;
        width: 85%;
        height: 50%;
        margin-left: auto;
        margin-right: auto;
        padding-top: 5%;

    }
    .paypal-button {
        width: 80%;
        height: 50%;
        margin-top: -5%;

        margin-right: auto;
        margin-left: auto;
    }

    .paypal-section {
        width: 100%;
        height: 100%;

    }

    #logo-area {
        width: 100%;
        height: 5%;
        margin: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-left: 2.5%;
        padding-right: 2.5%;

    }

    .logo-image-holder {

        width: 25%;
        height: 100%;
        float: left;
        background-size: 70%;
        background-position: center;

    }

    #service-selector {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 10%;
        margin: 0;

    }

    .bundle-info {

        font-size: 6vw;

        height: 100%;
        width: 90%;
        margin-left: auto;
        margin-right: auto;

        color: rgba(0,0,0,0.7);
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .bundle-info-desktop {


        font-size: 2.5vw;

        height: 100%;
        width: 100%;

        color: rgba(0,0,0,0.7);

    }

    .bundle-info-main {
        height: 35%;
        width: 100%;
        font-size: 75%;
        font-weight: bold;
    }
    .bundle-info-main-desktop {

        height: 40%;
        width: 100%;
        font-size: 45%;
        font-weight: bold;
    }
    .bundle-info-second {
        padding-top: 10%;
        width: 100%;
        font-size: 80%;
        font-weight: normal;
    }

    .bundle-info-second-desktop {
        padding-top: 5%;
        width: 100%;
        font-size: 80%;
        font-weight: normal;
    }


    #service-selector-buttons {

        color: white;
        font-size: 3vw;
        margin: 0;

    }

    #profile-content {
        width: 100%;
        height: 85%;
        margin: 0;

    }
    #profile-card{
        background-color: white;
        height: 100%;
        width: 87.5%;
        margin-right: auto;
        margin-left: auto;

        border-radius: 5px;
        background-size: cover;

    }

    #card-banner {

        height: 10%;
        width: 100%;
        border-top-left-radius: 7px;
        border-top-right-radius: 7px;
        background: white;
        display: flex;
        justify-content: center;
        align-items: center;

    }

    #card-banner-desktop {

        height: 60%;
        width: 100%;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        background: white;
        display: flex;
        justify-content: center;
        align-items: center;

    }

    #card-content {

        height: 70%;
        width: 100%;
        padding: 2.5%;

    }

    #card-content-desktop {
        height: 40%;
        width: 100%;
        padding: 1.5%;
    }

    #card-button {
        height: 20%;
        width: 100%;

    }

    .bundle-number {
        font-weight: bold;
        font-size: 5vw;
        padding-top: 0.5vw;
        width: 50%;
        height: 75%;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius:12.5px;
        margin: 0;
    }

    #bundle-number-desktop {
        font-weight: bold;
        font-size: 3vh;
        width: 85%;
        height: 70%;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius:12.5px;
        margin: 0;
    }


    /*Footer*/

    /*MODAL*/

    /*MODAL*/

    /*SUccess modal Start*/

    @keyframes thumbsUpAnimation {
        0% { transform: rotate(0deg); }
        10% { transform:  rotate(0deg); }
        20% { transform:  rotate(0deg); }
        30% { transform:  rotate(15deg); }
        40% { transform:  rotate(0deg); }
        50% { transform: rotate(0deg); }
        60% { transform:  rotate(0deg); }
        70% { transform:  rotate(0deg); }
        80% { transform:  rotate(0deg); }
        90% { transform: rotate(0deg); }
        100% { transform:  rotate(0deg); }
    }

    #portrait {
        height: 100%;
        width: 100%;
    }

    /*Success modal End*/

    /*OVERLAY*/

    #overlay-body {
        height: 80vh;
        width: 100vw;

    }

    .content-content-text-area{

        align-items: center;
        justify-content: center;
        height: 20%;
        width: 85%;
        margin-left: auto;
        margin-right: auto;

    }

    .content-animation-area {
        height: 80%;
        width: 100%;
        padding-top: 20%;
    }

    .content-text {
        font-size: 7.5vw;
        padding: 2vw;
        color: white;
        font-weight: bold;
    }

    .content-text-2 {
        font-size: 3.5vw;
        color: white;
        font-weight: bold;
        width: 100%;
        margin-left: auto;
        margin-right: auto;
    }

    #phone-animation {
        font-size: 35vh;
        position: relative;

    }

    #finger-animation{
        font-size: 25vh;
        position: relative;
        animation: swipeAnimation 5s;
        animation-iteration-count: infinite;
    }

    @keyframes swipeAnimation {
        0% { transform: translateY(-15vh) translateX(-7vw) ; opacity: 0;  }
        10% { transform: translateY(-15vh) translateX(-7vw) ; opacity: 1;  }
        40% { transform: translateY(-15vh) translateX(17vw) ; opacity: 1; }
        50% { transform: translateY(-15vh) translateX(17vw) ; opacity: 0; }
        60% { transform: translateY(-15vh) translateX(17vw) ; opacity: 1; }
        90% { transform: translateY(-15vh) translateX(-7vw) ; opacity: 1; }
        100% { transform: translateY(-15vh) translateX(-7vw) ; opacity: 0; }
    }

    #payment-success-modal {

        backdrop-filter: blur(3px);
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;

    }

    #payment-success-header {

        width: 100%;
        height: 20%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        font-size: 6vw;

    }

    #payment-success-content {

        width: 100%;
        height: 40%;
        font-size: 1.5vw;
        padding-left: 2%;
        padding-right: 2%;

    }

    #payment-success-footer {
        width: 100%;
        height: 10%;
    }

    #content-top {
        height: 20%;
        width: 100%;

        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 3.25vw;
    }

    #content-middle {
        height: 30%;
        width: 100%;

        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 3vw;
    }

    #content-bottom {
        height: 30%;
        width: 100%;

        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 2.5vw;

    }

    #content-number {
        width: 100%;
        height: 20%;
        padding-top: 2vh;

        font-size: 4vw;
    }

    #promo-alert {
        position: absolute;
        width: 100%;
        top: 0;
        animation: appear 3s;
        animation-iteration-count: 1;
    }

    @keyframes appear {

        0% { opacity: 0; }
        20% { opacity: 1; }
        50% { opacity: 1; }
        80% { opacity: 1; }
        100% { opacity: 0; }

        /*100% { transform: translateY(-15vh) translateX(-7vw) ; opacity: 0; }*/
    }

    #bronze-background {
        background: radial-gradient(ellipse farthest-corner at right top, #FFFFFF 0%, #e1b384 8%, #d7995b 25%, #905923 82.5%, #a46628 100%);
    }
    #silver-background {
        background: radial-gradient(ellipse farthest-corner at right top, #FFFFFF 0%, #b3b3b3 8%, #999999 25%, #404040 82.5%, #4d4d4d 100%)
    }
    #gold-background {
        background: radial-gradient(ellipse farthest-corner at right top, #FFFFFF 0%, #FFFFAC 8%, #D1B464 25%, #5d4a1f 82.5%, #5d4a1f 100%)
    }
    #platinum-background {
        background: radial-gradient(ellipse farthest-corner at right top, #e5e4e2 0%, #e5e4e2 8%, #e5e4e2 25%, #aaa7a1 82.5%, #5e5b55 100%)
    }

    #payment-loading {
        width: 100vw;
        height: 100vh;
        backdrop-filter: blur(3px);
    }

</style>
